export default function WhyChooseUs() {
  const benefits = [
    {
      icon: 'ri-speed-line',
      title: 'Rapidez y eficiencia',
      description: 'Completamos el vaciado en el menor tiempo posible sin comprometer la calidad del servicio. Nos adaptamos a tus plazos y urgencias.'
    },
    {
      icon: 'ri-recycle-line',
      title: 'Gestión responsable de residuos',
      description: 'Cumplimos con todas las normativas medioambientales. Reciclamos, donamos y eliminamos los residuos de forma legal y responsable.'
    },
    {
      icon: 'ri-team-line',
      title: 'Equipo profesional',
      description: 'Personal cualificado y experimentado que trata tus pertenencias con el máximo cuidado y respeto. Uniformados e identificados.'
    },
    {
      icon: 'ri-heart-line',
      title: 'Menos esfuerzo físico y emocional',
      description: 'Nos encargamos de todo el trabajo pesado y las decisiones difíciles, especialmente importante en casos de herencias o fallecimientos.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Totalmente asegurado',
      description: 'Contamos con seguro de responsabilidad civil que cubre cualquier incidencia durante el servicio. Tu tranquilidad es nuestra prioridad.'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Precios transparentes',
      description: 'Presupuestos claros y detallados sin costes ocultos. Sabrás exactamente qué pagas y por qué, sin sorpresas desagradables.'
    }
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-teal-50 to-cyan-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <span className="text-teal-600 font-semibold text-sm sm:text-base uppercase tracking-wide">
            Ventajas Competitivas
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-4 px-2">
            ¿Por qué contratar un servicio profesional de vaciado?
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto px-4">
            Vaciar un piso por tu cuenta puede ser agotador, estresante y costoso. Descubre las ventajas de confiar en profesionales.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 sm:p-8 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-xl flex items-center justify-center mb-5">
                <i className={`${benefit.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3">
                {benefit.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 md:p-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                Comparativa: Hacerlo tú mismo vs. Servicio profesional
              </h3>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <i className="ri-close-circle-line text-2xl text-red-500 flex-shrink-0 mt-1"></i>
                  <div>
                    <strong className="text-gray-900">Por tu cuenta:</strong>
                    <p className="text-sm text-gray-600">Días de trabajo físico intenso, alquiler de furgoneta, múltiples viajes al punto limpio, riesgo de lesiones, estrés emocional.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-2xl text-teal-600 flex-shrink-0 mt-1"></i>
                  <div>
                    <strong className="text-gray-900">Con VPB:</strong>
                    <p className="text-sm text-gray-600">Trabajo completado en horas, equipo profesional, vehículos propios, gestión legal de residuos, sin esfuerzo físico ni preocupaciones.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gradient-to-br from-teal-600 to-cyan-700 rounded-xl p-6 sm:p-8 text-white">
              <h4 className="text-lg sm:text-xl font-bold mb-4">Ahorra tiempo y dinero</h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-xl flex-shrink-0 mt-0.5"></i>
                  <span className="text-sm">No necesitas alquilar furgoneta ni contratar ayuda extra</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-xl flex-shrink-0 mt-0.5"></i>
                  <span className="text-sm">Evitas multas por mala gestión de residuos</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-xl flex-shrink-0 mt-0.5"></i>
                  <span className="text-sm">No pierdes días de trabajo ni fines de semana</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-xl flex-shrink-0 mt-0.5"></i>
                  <span className="text-sm">Precio final más económico que hacerlo por tu cuenta</span>
                </li>
              </ul>
              <button
                onClick={() => {
                  const element = document.getElementById('contacto');
                  element?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="mt-6 w-full bg-white text-teal-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                Solicita tu presupuesto gratis
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
